import axios from "axios";
import { AnyAction, Dispatch } from "redux";
import * as actions from "../actions/middlwares/api";
import { ucAppserverBaseUrl } from "../config/config";
import { delayBeforeHideFailureMessage, delayBeforeHideSuccessMessage } from "../config/constants";
import { AppDispatch } from "../reducers";
import {
  showFailureMessage,
  hideFailureMessage,
  showSuccessMessage,
  hideSuccessMessage
} from "../store/statusMessages";
import { getErrorMessageFromRequest } from "../utils/utils";

const api = ({ dispatch }: { dispatch: AppDispatch }) => (next: Dispatch) => async (
  action: AnyAction
) => {
  if (action.type !== actions.apiCallBegan.type) {
    return next(action);
  }

  const {
    url,
    method,
    data,
    params,
    onStart,
    onSuccess,
    onFailure,
    onSuccessMessage,
    onFailureMessage,
    responseType
  } = action.payload;

  if (onStart) {
    dispatch(onStart());
  }

  next(action);

  try {
    const response = await axios.request({
      baseURL: ucAppserverBaseUrl,
      url,
      method,
      data,
      params,
      responseType
    });
    dispatch(actions.apiCallSuccess);

    if (onSuccessMessage) {
      dispatch(showSuccessMessage(onSuccessMessage));
      setTimeout(() => {
        dispatch(hideSuccessMessage());
      }, delayBeforeHideSuccessMessage);
    }
    if (onSuccess) {
      dispatch(onSuccess(response.data));
    }
  } catch (error) {
    dispatch(actions.apiCallFailed(error));
    if (onFailureMessage) {
      dispatch(showFailureMessage(onFailureMessage, getErrorMessageFromRequest(error as any)));
      setTimeout(() => dispatch(hideFailureMessage()), delayBeforeHideFailureMessage);
    }
    if (onFailure) {
      dispatch(onFailure(error));
    }
  }
};

export default api;
